import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {
  BreadcrumbModule,
  EmptyStateModule,
  ModalModule,
  PaginatorModule,
  TableModule,
  StatusModule,
  IconModule,
  ThemingModule,
  ScrollbarModule,
  DropdownModule,
  AlertModule
} from '@michelin/theme';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { MatTabsModule } from '@angular/material/tabs';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../../shared/shared.module';
import { ProductDataContainerComponent } from './components/product-data-container/product-data-container.component';
import { PreMoldScreenComponent } from './components/pre-mold-screen/pre-mold-screen.component';
import { FinishedProductScreenComponent } from './components/finished-product-screen/finished-product-screen.component';
import { CasingSizeComponent } from './components/casing-size/casing-size.component';
import { CustomMoldScreenComponent } from './components/custom-mold-screen/custom-mold-screen.component';
import { CasingCreditComponent } from './components/casing-credit/casing-credit.component';
import { MakeComponent } from './components/make-screen/make-screen.component';
import { CasingGradeComponent } from './components/casing-grade/casing-grade.component';
import { FreeRepairComponent } from './components/free-repair/free-repair.component';
import { CasingCreditRepairComponent } from './components/casing-credit-repair/casing-credit-repair.component';
import { CasingCreditRepairDetailsComponent } from './components/casing-credit-repair-details/casing-credit-repair-details.component';
import { DisposalChargesComponent } from './components/disposal-charges/disposal-charges.component';
import { CasingCreditRepairCreateComponent } from './components/casing-credit-repair-create/casing-credit-repair-create.component';
import { CasingCreditCopyComponent } from './components/casing-credit-copy/casing-credit-copy.component';
import { RejectReasonsComponent } from './components/reject-reasons/reject-reasons.component';
import { CasingGradeTableDetailsComponent } from './components/casing-grade-table-details/casing-grade-table-details.component';
import { CasingGradeTableComponent } from './components/casing-grade-table/casing-grade-table.component';
import { RerunReworkReasonComponent } from './components/rerun-rework-reason/rerun-rework-reason.component';
import { RepairsComponent } from './components/repairs/repairs.component';
import { FreeRepairSetupComponent } from './components/free-repair-setup/free-repair-setup.component';
import { IsDeletablePipe } from './pipes/is-deletable.pipe';
import { CasingDefinitionComponent } from './components/casing-definition/casing-definition.component';
import { FactoryCodeComponent } from './components/factory-code/factory-code.component';
import { AdjustmentReasonsComponent } from './components/adjustment-reasons/adjustment-reasons.component';
import { ProductApplicationComponent } from './components/product-application/product-application.component';
import { ProductAxleComponent } from './components/product-axle/product-axle.component';
import { CasingFitmentComponent } from './components/casing-fitment/casing-fitment.component';
import { CasingPurchaseComponent } from './components/casing-purchase/casing-purchase.component';
import { CasingPurchaseSetupComponent } from './components/casing-purchase-setup/casing-purchase-setup.component';
import { WheelAndTireServicesComponent } from './components/wheel-and-tire-services/wheel-and-tire-services.component';
import { WheelsComponent } from './components/wheels/wheels.component';
import { WheelColorComponent } from './components/wheel-color/wheel-color.component';

@NgModule({
  declarations: [
    ProductDataContainerComponent,
    PreMoldScreenComponent,
    FinishedProductScreenComponent,
    CustomMoldScreenComponent,
    CasingSizeComponent,
    CasingDefinitionComponent,
    CasingFitmentComponent,
    FactoryCodeComponent,
    AdjustmentReasonsComponent,
    ProductApplicationComponent,
    ProductAxleComponent,
    DisposalChargesComponent,
    CasingCreditComponent,
    FreeRepairComponent,
    MakeComponent,
    CasingGradeComponent,
    CasingCreditRepairComponent,
    RepairsComponent,
    RejectReasonsComponent,
    CasingCreditRepairComponent,
    CasingGradeTableComponent,
    CasingGradeTableDetailsComponent,
    RerunReworkReasonComponent,
    CasingPurchaseComponent,
    WheelAndTireServicesComponent,
    WheelsComponent,
    WheelColorComponent,
    IsDeletablePipe
  ],
  exports: [
    ProductDataContainerComponent,
    PreMoldScreenComponent,
    FinishedProductScreenComponent,
    CustomMoldScreenComponent,
    CasingSizeComponent,
    CasingDefinitionComponent,
    CasingFitmentComponent,
    FactoryCodeComponent,
    AdjustmentReasonsComponent,
    ProductApplicationComponent,
    ProductAxleComponent,
    DisposalChargesComponent,
    CasingCreditCopyComponent,
    FreeRepairComponent,
    FreeRepairSetupComponent,
    CasingGradeComponent,
    MakeComponent,
    CasingCreditRepairComponent,
    CasingCreditRepairCreateComponent,
    CasingCreditRepairDetailsComponent,
    RejectReasonsComponent,
    CasingGradeTableDetailsComponent,
    CasingGradeTableComponent,
    CasingPurchaseComponent,
    RepairsComponent,
    WheelAndTireServicesComponent,
    WheelsComponent,
    WheelColorComponent
  ],
  imports: [
    TableModule,
    BreadcrumbModule,
    EmptyStateModule,
    PaginatorModule,
    CommonModule,
    ModalModule,
    StatusModule,
    IconModule,
    ThemingModule,
    FormsModule,
    ReactiveFormsModule,
    ScrollbarModule,
    DropdownModule,
    SharedModule,
    AlertModule,
    MatTabsModule,
    MatMenuModule,
    MatIconModule,
    DragDropModule,
    RouterModule,
    CasingCreditRepairDetailsComponent,
    CasingCreditRepairCreateComponent,
    CasingCreditCopyComponent,
    FreeRepairSetupComponent,
    CasingPurchaseSetupComponent
  ]
})
export class ProductDataModule {}
